import React, {useState, useEffect, useCallback} from "react";

import MaterialTable, { MTableHeader, MTableBody } from "material-table";
import { History } from "@material-ui/icons";
import useAPI from "../../../hooks/useAPI";
import {
  localization,
  modifyDefaultOptions,
  tableIconsModified,
  arrayToLookup,
  styledHeaderSticky,
} from "../../../helpers/table";
import FilterMultiSelect from "../../../components/table/FilterMultiSelect";
import HistoryModal from "./HistoryModal";
import {Link, NavLink, useHistory} from "react-router-dom";
import LoadingTable from '../../../components/table/LoadingTable';

export default function NonUnifiedTable() {
  const api = useAPI();
  const history = useHistory();
  const [modal, setModal] = useState(null);
  const [data, setData] = useState([]);
  const [types, setTypes] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(async () => {
    await getData();
    setIsLoaded(true)
  }, []);

  const pushToProject = useCallback((projId) => {
    api.get(`/projs/${projId}`).then((res)=>history.push({
      pathname:`/strats/${res.strategyId}/projs/${res.id}?isHistory=1`,
      state: { showOldVersion: true }
    }))
  }, [history,data]);

  const getData = async () => {
    try {
      const result = await api.get("/projs/0/pcs");
      const types = await api.get("/mng/proj/types");
      setData(result.map((e) => ({ ...e,
        projHeadName: e.proj.head.displayName,
        projName: `${e.proj.fullNumber} ${e.proj.name}`,
      })));
      setTypes(types);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "№",
      field: "index",
      filtering: false,
      minWidth: "60px",
      maxWidth: "60px",
    },
    { title: "Наименование показателя", field: "name", minWidth: "380px" },
    { title: "Единицы измерения", field: "unit", filtering: false, maxWidth: '120px' },
    {
      title: "Тип проекта",
      field: "proj.type.name",
      lookup: arrayToLookup("name", types),
      minWidth: "150px",
      filterComponent: FilterMultiSelect,
      customFilterAndSearch: (term, rowData) => {
        if (term.length == 0) return true;
        const res = term.filter((x) => [rowData.proj?.type?.name].map((e) => e).includes(x));
        return res.length > 0;
      },
    },
    {
      title: "№ и наименование проекта",
      field: "projName",
      render:(rowData)=><Link onClick={()=>pushToProject(rowData.projId)}>{rowData.projName}</Link>,
      lookup: arrayToLookup("projName", data),
      minWidth: "400px",
      filterComponent: FilterMultiSelect,
    },
    {
      title: "Руководитель проекта",
      field: "projHeadName",
      lookup: arrayToLookup("projHeadName", data),
      minWidth: "200px",
      filterComponent: FilterMultiSelect,
    },
    {
      title: "Версия ЦП",
      field: "proj.version",
      minWidth: "100px",
      maxWidth: "100px",
      filtering: false,
    },
    // { title: "Портфель", field: "proj.portfName", filterComponent: FilterMultiSelect },
  ];

  return (
    <div>
      <MaterialTable
        title=""
        components={{
          Container: (props) => <div className="special-filter-without-max" {...props} />,
          Body: (props) => (
            <LoadingTable spinnerStyle={{marginTop: '40px'}} loadingObject={{isLoaded}}>
              <MTableBody {...props} />
              <div id="portal-root"></div>
            </LoadingTable>
          ),
          Header: (props) => <MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />,
        }}
        options={modifyDefaultOptions({
          toolbar: false,
          maxBodyHeight: "85vh",
          filterCellStyle: {
            position: "sticky",
            top: 48,
            background: "white",
          },
        })}
        // actions={[
        //   (rowData) => ({
        //     custom: true,
        //     icon: () => <History style={{ color: "#0D6EFD" }} />,
        //     tooltip: "История версий",
        //     onClick: () => {
        //       setModal(true);
        //     },
        //   }),
        // ]}
        icons={tableIconsModified}
        localization={localization}
        columns={columns}
        data={data.map((e, i) => ({ ...e, index: i + 1 }))}
      />
      {modal && <HistoryModal index={modal} onClose={() => setModal(null)} />}
    </div>
  );
}
